import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = { class: "d-flex align-center mr-4" }

import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { locale } = useI18n();

function onClickKoKr() {
  locale.value = "ko";
  localStorage.setItem("user-locale", "ko");
}

function onClickEnUs() {
  locale.value = "en";
  localStorage.setItem("user-locale", "en");
}

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        color: "surface",
        elevation: "0",
        style: {"border-bottom":"1px solid #dcecf7 !important"},
        "px-4": ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_img, {
              src: "/boditech.png",
              height: "42",
              width: "150",
              contain: "",
              alt: "Boditech Logo"
            })
          ]),
          _createVNode(_component_v_spacer),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_btn, {
              variant: "text",
              size: "small",
              color: _unref(locale) === 'ko' ? 'primary' : 'grey-darken-1',
              class: _normalizeClass({ 'font-weight-bold': _unref(locale) === 'ko' }),
              onClick: onClickKoKr
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 한국어 ")
              ]),
              _: 1
            }, 8, ["color", "class"]),
            _createVNode(_component_v_divider, {
              vertical: "",
              inset: "",
              class: "mx-2 my-auto",
              style: {"height":"14px","border-color":"#dcecf7"}
            }),
            _createVNode(_component_v_btn, {
              variant: "text",
              size: "small",
              color: _unref(locale) === 'en' ? 'primary' : 'grey-darken-1',
              class: _normalizeClass({ 'font-weight-bold': _unref(locale) === 'en' }),
              onClick: onClickEnUs
            }, {
              default: _withCtx(() => [
                _createTextVNode(" English ")
              ]),
              _: 1
            }, 8, ["color", "class"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      _createVNode(_component_v_footer, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, { fluid: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { class: "text-center mb-10" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createTextVNode(" © Boditech Med Inc. All rights reserved. ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})